import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'
import { setCookie } from '../../GlobalMethods'
import { FoundationsRequest, getBaseUrl, getUrlVars, toBinary } from '../../Utils'
import { formHelp } from './formHelpers'

const defaults = {
    createNavigationPanel: false,
    drillThruObj: undefined,
}

declare let window: any

export const formNavigation = {
    navigateThroughWorklist: function (
        params: {
            direction: any
            columnsData: { [key: string]: string }
            drillthruObj: any
        },
        formName: string,
        dataObjectId: string,
        setTabGuid: any,
        setDrillThruObj: any,
        setPopUpInfo: (
            title: string,
            message: string,
            isError: boolean,
            delay: number,
            buttons: any[]
        ) => void,
        setShowPopupMessage: (show: boolean) => void
    ) {
        const direction = params.direction
        const drillthruObjValues = Object.values(params.columnsData)
        const drillthruObjKeys = Object.keys(params.columnsData)
        const dateParts = drillthruObjValues[0].match(/(\d+)/g)
        if (dateParts && dateParts.length === 6) {
            const [day, month, year, hours, minutes, seconds] = dateParts
            const detectedDate = new Date(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}`)
            const isValidDate = !isNaN(detectedDate.getTime())
            if (isValidDate) {
                const [day, month, year, hours, minutes, seconds] = drillthruObjValues[0].match(
                    /\d+/g
                ) as string[]
                const convertedDateString = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`
                params.columnsData[drillthruObjKeys[0]] = convertedDateString
            }
        }

        // TODO fix how engine type is read
        // const engineType = $(".engineType_div").attr("enginetype").toLowerCase() == 'no' ? 'oldengine' : 'newengine';
        const engineType = 'newengine'
        const varData = !params.drillthruObj
            ? getUrlVars()
            : JSON.parse(formHelp.fromBinary(params.drillthruObj))

        const reqDrillThruData = {
            dashBoardId: -1,
            vuId: varData['vuId'],
            vuTempId: varData['tempId'],
            drillThruDP: varData['drillThruDP'],
            measureId: varData['measureId'],
            pageSize: 1,
            drillThruSearchString:
                varData['drillThruSearchString'] == null ? '' : varData['drillThruSearchString'],
            InputSearchList: varData['InputSearchList'] !== '' ? varData['InputSearchList'] : null,
            drillThruSetId: varData['drillThrusetId'],
            //isAutoLockAllowed: varData["isAutoLockAllowed"],
            columnsData: params.columnsData,
            EngineType: engineType,
            pageNumber: direction == 'forward' ? 1 : undefined,
            SortColumns: undefined,
            tempVisualUnitId: undefined,
        }

        FoundationsRequest('POST', {
            url:
                getBaseUrl() +
                'API/v3/DrillThru/' +
                reqDrillThruData.drillThruSetId +
                '/' +
                reqDrillThruData.vuId,
            cache: false,
            data: JSON.stringify(reqDrillThruData),
            includeTokenHeader: true,
            success: function (response: { data: any; statusCode: number } | null) {
                if (response != null) {
                    const responseData = response.data
                    if (responseData != null) {
                        if (response.statusCode == 201) {
                            formHelp.checkandremove_Issingletoncookies(formName, dataObjectId) //FP-5973 Adding remove cookies call on next and closebutton click.
                            const drillThroughDataAsJSON = responseData.drillThroughDataAsJSON
                            //sortcolumns
                            const sortColumnsList = responseData['SortColumns']
                            if (Object.keys(drillThroughDataAsJSON).length > 0) {
                                let delayInMilliseconds = 0
                                if (responseData.RevisitDrillthru) {
                                    setPopUpInfo(
                                        'Form Navigation Alert',
                                        'Relaunching the first record from the drillthru.',
                                        false,
                                        2000,
                                        []
                                    )
                                    setShowPopupMessage(true)
                                    delayInMilliseconds = 2000
                                }
                                setTimeout(function () {
                                    const tableHeading = []
                                    let renderMetaDataMDSColumns =
                                        responseData['renderMetadata']['mdsColumnData']
                                    for (let rowKey in drillThroughDataAsJSON) {
                                        if (drillThroughDataAsJSON.hasOwnProperty(rowKey)) {
                                            const jsonRow = drillThroughDataAsJSON[rowKey]
                                            for (let colKey in jsonRow) {
                                                if (jsonRow.hasOwnProperty(colKey)) {
                                                    tableHeading.push(colKey.toLowerCase())
                                                }
                                            }
                                            break
                                        }
                                    }
                                    for (let rowKey in drillThroughDataAsJSON) {
                                        let jsonRow = drillThroughDataAsJSON[rowKey]
                                        if (drillThroughDataAsJSON.hasOwnProperty(rowKey)) {
                                            jsonRow = drillThroughDataAsJSON[rowKey]
                                            const jsonRowEncrypyedList = []
                                            const sortColumnsData: {
                                                [key: string]: string | undefined
                                            } = {}
                                            const jsonRowList = []
                                            for (let colKey in jsonRow) {
                                                if (jsonRow.hasOwnProperty(colKey)) {
                                                    if (typeof jsonRow[colKey] == 'object') {
                                                        jsonRowEncrypyedList.push(
                                                            jsonRow[colKey].EncryptedKey
                                                        )
                                                        jsonRowList.push(jsonRow[colKey].Key)
                                                        jsonRow[colKey] = jsonRow[colKey].Key
                                                    } else {
                                                        jsonRowList.push(jsonRow[colKey])
                                                        jsonRowEncrypyedList.push(null)
                                                    }

                                                    if (
                                                        sortColumnsList &&
                                                        jsonRow.hasOwnProperty(colKey)
                                                    ) {
                                                        sortColumnsList.forEach(
                                                            function (tempSortColumn: {
                                                                FieldName: string
                                                            }) {
                                                                if (
                                                                    tempSortColumn.FieldName ==
                                                                    colKey
                                                                )
                                                                    sortColumnsData[colKey] =
                                                                        jsonRow[colKey]
                                                            }
                                                        )
                                                    }
                                                }
                                            }

                                            renderMetaDataMDSColumns =
                                                responseData['renderMetadata']['mdsColumnData']

                                            //find the column position using MDSColumnid and not depending on the drillthru launcher position
                                            //even if user drags the column or sets view, this column position will be determined from DB sequence
                                            //using MDSColumnid
                                            let colCounter = 0
                                            if (renderMetaDataMDSColumns != null) {
                                                for (
                                                    let i = 0;
                                                    i < renderMetaDataMDSColumns.length;
                                                    i++
                                                ) {
                                                    if (
                                                        varData['MDSColumnId'] != null &&
                                                        renderMetaDataMDSColumns[i][
                                                            'MDSColumnId'
                                                        ] != null &&
                                                        renderMetaDataMDSColumns[i][
                                                            'MDSColumnId'
                                                        ] == varData['MDSColumnId']
                                                    ) {
                                                        colCounter = i
                                                    }
                                                }
                                            }

                                            let deepLinkURL = ''
                                            for (let colKey in jsonRow) {
                                                if (jsonRow.hasOwnProperty(colKey)) {
                                                    if (
                                                        renderMetaDataMDSColumns[colCounter][
                                                            'hideInDrillThru'
                                                        ] == '' ||
                                                        renderMetaDataMDSColumns[colCounter][
                                                            'hideInDrillThru'
                                                        ].toLowerCase() == 'false'
                                                    ) {
                                                        if (
                                                            renderMetaDataMDSColumns[colCounter][
                                                                'javascriptTarget'
                                                            ]
                                                        ) {
                                                            let functionParamsString =
                                                                renderMetaDataMDSColumns[
                                                                    colCounter
                                                                ]['javascriptTargetParams']
                                                            let templatedParams = []
                                                            let namedParams =
                                                                renderMetaDataMDSColumns[
                                                                    colCounter
                                                                ]['javascriptTargetParams'].match(
                                                                    /\$[\w\s]+\$/gi
                                                                )
                                                            let indexedParams =
                                                                renderMetaDataMDSColumns[
                                                                    colCounter
                                                                ]['javascriptTargetParams'].match(
                                                                    /\$\d+/gi
                                                                )
                                                            if (namedParams) {
                                                                for (
                                                                    let i = 0;
                                                                    i < namedParams.length;
                                                                    i++
                                                                ) {
                                                                    templatedParams.push(
                                                                        namedParams[i]
                                                                    )
                                                                }
                                                            }
                                                            if (indexedParams) {
                                                                for (
                                                                    let i = 0;
                                                                    i < indexedParams.length;
                                                                    i++
                                                                ) {
                                                                    templatedParams.push(
                                                                        indexedParams[i]
                                                                    )
                                                                }
                                                            }
                                                            for (let match in templatedParams) {
                                                                let positionalParam =
                                                                    templatedParams[match].replace(
                                                                        /\$/g,
                                                                        ''
                                                                    )
                                                                positionalParam = isNaN(
                                                                    positionalParam
                                                                )
                                                                    ? tableHeading.indexOf(
                                                                          positionalParam.toLowerCase()
                                                                      )
                                                                    : Number(positionalParam)
                                                                functionParamsString =
                                                                    functionParamsString.replace(
                                                                        templatedParams[match],
                                                                        jsonRowList[positionalParam]
                                                                    )
                                                            }

                                                            templatedParams = []
                                                            namedParams =
                                                                renderMetaDataMDSColumns[
                                                                    colCounter
                                                                ]['javascriptTargetParams'].match(
                                                                    /\~[\w\s]+\~/gi
                                                                )
                                                            if (namedParams) {
                                                                for (
                                                                    let i = 0;
                                                                    i < namedParams.length;
                                                                    i++
                                                                ) {
                                                                    templatedParams.push(
                                                                        namedParams[i]
                                                                    )
                                                                }
                                                            }
                                                            indexedParams =
                                                                renderMetaDataMDSColumns[
                                                                    colCounter
                                                                ]['javascriptTargetParams'].match(
                                                                    /\~\d+/gi
                                                                )
                                                            if (indexedParams) {
                                                                for (
                                                                    let i = 0;
                                                                    i < indexedParams.length;
                                                                    i++
                                                                ) {
                                                                    templatedParams.push(
                                                                        indexedParams[i]
                                                                    )
                                                                }
                                                            }
                                                            for (let match in templatedParams) {
                                                                let positionalParam =
                                                                    templatedParams[match].replace(
                                                                        /\~/g,
                                                                        ''
                                                                    )
                                                                positionalParam = isNaN(
                                                                    positionalParam
                                                                )
                                                                    ? tableHeading.indexOf(
                                                                          positionalParam.toLowerCase()
                                                                      )
                                                                    : Number(positionalParam)
                                                                functionParamsString =
                                                                    functionParamsString.replace(
                                                                        templatedParams[match],
                                                                        jsonRowEncrypyedList[
                                                                            positionalParam
                                                                        ]
                                                                    )
                                                            }
                                                            switch (
                                                                renderMetaDataMDSColumns[
                                                                    colCounter
                                                                ]['javascriptTarget']
                                                            ) {
                                                                default:
                                                                    if (
                                                                        renderMetaDataMDSColumns[
                                                                            colCounter
                                                                        ][
                                                                            'javascriptTarget'
                                                                        ].includes('$baseurl')
                                                                    ) {
                                                                        deepLinkURL =
                                                                            renderMetaDataMDSColumns[
                                                                                colCounter
                                                                            ][
                                                                                'javascriptTarget'
                                                                            ].replace(
                                                                                '$baseurl',
                                                                                getBaseUrl()
                                                                            )

                                                                        templatedParams =
                                                                            deepLinkURL.match(
                                                                                /\$\d+/gi
                                                                            ) as string[]
                                                                        for (let match in templatedParams) {
                                                                            const positionalParam =
                                                                                Number(
                                                                                    templatedParams[
                                                                                        match
                                                                                    ].replace(
                                                                                        '$',
                                                                                        ''
                                                                                    )
                                                                                )
                                                                            deepLinkURL =
                                                                                deepLinkURL.replace(
                                                                                    templatedParams[
                                                                                        match
                                                                                    ],
                                                                                    jsonRowList[
                                                                                        positionalParam
                                                                                    ]
                                                                                )
                                                                        }

                                                                        templatedParams =
                                                                            deepLinkURL.match(
                                                                                /\~\d*/gi
                                                                            ) as string[]
                                                                        for (let match in templatedParams) {
                                                                            const positionalParam =
                                                                                Number(
                                                                                    templatedParams[
                                                                                        match
                                                                                    ].replace(
                                                                                        '~',
                                                                                        ''
                                                                                    )
                                                                                )
                                                                            deepLinkURL =
                                                                                deepLinkURL.replace(
                                                                                    templatedParams[
                                                                                        match
                                                                                    ],
                                                                                    jsonRowEncrypyedList[
                                                                                        positionalParam
                                                                                    ]
                                                                                )
                                                                        }
                                                                    }
                                                            }
                                                            const requestEncodedObj = {
                                                                vuId: reqDrillThruData.vuId,
                                                                pageNumber:
                                                                    reqDrillThruData.pageNumber,
                                                                pageSize: reqDrillThruData.pageSize,
                                                                colCounter: colCounter,
                                                                drillThruDP:
                                                                    reqDrillThruData.drillThruDP,
                                                                SortColumns:
                                                                    reqDrillThruData.SortColumns,
                                                                measureId:
                                                                    reqDrillThruData.measureId,
                                                                tempId: reqDrillThruData.tempVisualUnitId,
                                                                isNavigationAllowed:
                                                                    varData['isNavigationAllowed'],
                                                                isAutoLockAllowed:
                                                                    varData['isAutoLockAllowed'],
                                                                drillThrusetId:
                                                                    reqDrillThruData.drillThruSetId,
                                                                drillThruSearchString:
                                                                    varData[
                                                                        'drillThruSearchString'
                                                                    ] == null
                                                                        ? ''
                                                                        : varData[
                                                                              'drillThruSearchString'
                                                                          ],
                                                                InputSearchList:
                                                                    varData['InputSearchList'], // reqDrillThruData.InputSearchList,
                                                                columnsData: sortColumnsData,
                                                                MDSColumnId:
                                                                    renderMetaDataMDSColumns[
                                                                        colCounter
                                                                    ]['MDSColumnId'],
                                                            }

                                                            let baseURLForLauncher = ''
                                                            if (
                                                                deepLinkURL != null &&
                                                                deepLinkURL != '' &&
                                                                deepLinkURL.includes('FormsEngine')
                                                            ) {
                                                                const newGuid =
                                                                    formHelp.generateGuid()
                                                                baseURLForLauncher =
                                                                    deepLinkURL +
                                                                    (functionParamsString
                                                                        ? '?' +
                                                                          (functionParamsString +
                                                                              '&guid=' +
                                                                              newGuid) +
                                                                          '&navigationenabled=' +
                                                                          varData[
                                                                              'isNavigationAllowed'
                                                                          ]
                                                                        : '?guid=' +
                                                                          newGuid +
                                                                          '&navigationenabled=' +
                                                                          varData[
                                                                              'isNavigationAllowed'
                                                                          ])
                                                                setTabGuid(newGuid)
                                                                setDrillThruObj(requestEncodedObj)
                                                            } else {
                                                                deepLinkURL =
                                                                    deepLinkURL +
                                                                    (functionParamsString
                                                                        ? '?'
                                                                        : '') +
                                                                    functionParamsString +
                                                                    (functionParamsString
                                                                        ? '&'
                                                                        : '?') +
                                                                    'drillThruParams=' +
                                                                    toBinary(
                                                                        JSON.stringify(
                                                                            requestEncodedObj
                                                                        )
                                                                    )
                                                            }

                                                            // ===== Get dataObjectId to store drillThruObj for next form =====
                                                            let params = baseURLForLauncher
                                                                .split('?')[1]
                                                                .split('&')
                                                            let newDataObjectId = ''
                                                            for (
                                                                var i = 0;
                                                                i < params.length;
                                                                i++
                                                            ) {
                                                                var tempParam = params[i].split('=')

                                                                if (
                                                                    tempParam[0].toLowerCase() ==
                                                                    'dataobjectid'
                                                                ) {
                                                                    newDataObjectId = tempParam[1]
                                                                }
                                                            }
                                                            sessionStorage.setItem(
                                                                `_drillThruObj_${newDataObjectId}`,
                                                                JSON.stringify(requestEncodedObj)
                                                            )
                                                            // ===== end storing drillThruObj for next form =====

                                                            try {
                                                                if (
                                                                    baseURLForLauncher ==
                                                                        window.location.href ||
                                                                    deepLinkURL ==
                                                                        window.location.href
                                                                ) {
                                                                    location.reload()
                                                                } else if (
                                                                    deepLinkURL != null &&
                                                                    deepLinkURL != '' &&
                                                                    deepLinkURL.includes(
                                                                        'FormsEngine'
                                                                    )
                                                                ) {
                                                                    const tabGuid =
                                                                        getUrlVars()['guid']
                                                                    setCookie(
                                                                        'drillthrudata_' + tabGuid,
                                                                        '',
                                                                        -15
                                                                    )
                                                                    window.location.replace(
                                                                        baseURLForLauncher
                                                                    )
                                                                } else {
                                                                    window.location.replace(
                                                                        deepLinkURL
                                                                    )
                                                                }
                                                                return false
                                                            } catch (ex) {}
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }, delayInMilliseconds)
                            } else {
                                setPopUpInfo(
                                    'Form Alert',
                                    'All forms are completed.Closing the window.',
                                    false,
                                    2000,
                                    []
                                )
                                setShowPopupMessage(true)
                                try {
                                    // TODO handle peer review some other way!
                                    window.chrome.runtime.sendMessage(window.PR.extensionID, {
                                        command: 'Close',
                                        accessionNum: window.PR.accessionNumber,
                                        patientMRN: window.PR.mrn,
                                    })
                                } catch (e) {}
                                window.setTimeout(function () {
                                    const tabGuid = getUrlVars()['guid']
                                    setCookie('drillthrudata_' + tabGuid, '', -15)
                                    const ww = window.open(location, '_self')
                                    ww.close()
                                }, 3000)
                            }
                        }
                    }
                }
            },
            error: function (request: any, err: any) {
                // window.healthLevelGlobal.handleAjaxPageError(request, err)
                console.error(err)
            },
        })
    },
    navigateToNextForm: function (
        isNavigationEnabled: string,
        isCopyPasted: string | undefined,
        formName: string,
        dataObjectId: string,
        drillThruObj: undefined | { [s: string]: any },
        setTabGuid: (s: string) => void,
        setDrillThruObj: (o: { [s: string]: any }) => void,
        setPopUpInfo: (
            title: string,
            message: string,
            hidePopup: boolean,
            delay: number,
            buttons: any[]
        ) => void,
        setShowPopupMessage: (show: boolean) => void
    ) {
        if (!drillThruObj) {
            FoundationsGenericToaster('error', 'Form data missing')
        } else {
            const _drillThruParams = toBinary(JSON.stringify(drillThruObj))
            if (isNavigationEnabled == 'true' && (!isCopyPasted || isCopyPasted !== 'false')) {
                setPopUpInfo(
                    'Form Navigation Alert',
                    'Search for next available form.',
                    false,
                    -1,
                    []
                )
                setShowPopupMessage(true)
                formNavigation.navigateThroughWorklist(
                    {
                        direction: 'forward',
                        drillthruObj: _drillThruParams,
                        columnsData: drillThruObj?.columnsData,
                    },
                    formName,
                    dataObjectId,
                    setTabGuid,
                    setDrillThruObj,
                    setPopUpInfo,
                    setShowPopupMessage
                )
            }
        }
    },
}
